export default __webpack_public_path__ + "static/media/BR_flag.ddf51989.svg";